// extracted by mini-css-extract-plugin
export default {"homeTextComponent":"HomeTextComponent_homeTextComponent__1nDRW"};